<template>
  <div class="landing-view min-h-screen">
    <!-- Navbar -->
    <LandingNavbar />

    <!-- Main Content -->
    <main
      class="flex flex-col flex-1 overflow-x-hidden"
    >
      <HeroSection />
      <FeaturesSection />
      <StatsBanner />
      <FellowsPitchSection />
    </main>

    <!-- Footer -->
    <FooterSection />
  </div>
</template>

<script setup lang="ts">
import LandingNavbar from '@/components/landing/LandingNavbar.vue'
import HeroSection from '@/components/landing/HeroSection.vue'
import FeaturesSection from '@/components/landing/FeaturesSection.vue'
import StatsBanner from '@/components/landing/StatsBanner.vue'
import FellowsPitchSection from '@/components/landing/FellowsPitchSection.vue'
import FooterSection from '@/components/landing/FooterSection.vue'
</script>

<style scoped>
.landing-view :deep(h1),
.landing-view :deep(h2),
.landing-view :deep(h3) {
  font-family: 'Outfit', sans-serif;
}

html,
body {
  scroll-behavior: smooth;
}
</style>
